export default __webpack_public_path__ + "static/media/img1.c4fdde85.jpg";